export enum TrackingActions {
	SECTION_SWITCH = 'section_switch',
	CONTENT_SWITCHER_SWITCHED = 'content_switcher_switched',
	RECOMMENDATIONS_GIVEN = 'recommendations_given',
	RECOMMENDATION_CLICK = 'recommendations_click',
	RECOMMENDATIONS_RENDERED = 'recommendations_rendered',
	RECOMMENDATIONS_RETRY_LOADING = 'recommendations_retry_loading',
}
